import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as PusherTypes from 'pusher-js';

import { WebsocketService } from '@core/services/websocket/websocket.service';
import * as Objects from '@core/objects';
import { OnlineUserService } from '@core/services/online-user/online-user.service';


import { Session } from 'app/store/models/session.model';

import * as fromUsersOnlineState from '@app/store/state/users-online/users-online.state';
import * as fromUsersOnlineActions from '@app/store/state/users-online/users-online.actions';

@Injectable({
    providedIn: 'root'
})
export class UsersOnlineService implements OnlineUserService {
    private onlineChannel: PusherTypes.PresenceChannel;

    // private sessionSubscriptor: Subscription;
    // private organizationSubscriptor: Subscription;

    // private session: SessionPackage = null;
    private session: Session = null;
    // private organization: number = null;
    private members: string[] = [];
    private membersSubscription: Subscription;
    constructor(
        // private appSrv: AppService,
        private websocket: WebsocketService,
        private store: Store<fromUsersOnlineState.UsersOnline>
    ) {}
    
    start(session: Session) {
        this.membersSubscription = this.selectConnectedUserIds().subscribe((members: Array<string>) => this.members = members);
        this.init(session);
    }

    end() {
        // unbind channels
        this.websocket.unbind(this.onlineChannel);
        this.membersSubscription.unsubscribe();
    
        this.session = null;
    }

    private init(session: Session) {

        // first time
        if(session == null)
            return;
        
        // check if change org
        if(this.session !== null && this.session.current.organization === session.current.organization)
            return;
        
        this.session = session;

        this.websocket.unbind(this.onlineChannel);
        this.onlineChannel = this.websocket.subscribeChannel('presence-org_'+this.session.current.organization.id);

        // online presence channel listeners

        this.onlineChannel.bind("pusher:subscription_succeeded", (members) => {
            
            // console.log("count members-->", members.count);
            // console.log("members-->", members);
          
            members.each((member) => {
            //   this.addUser(member.info);
              this.addUser(member.info);
;
            });
        });

        this.onlineChannel.bind("pusher:member_added", (member) => {
            this.addUser(member.info);
        });

        this.onlineChannel.bind("pusher:member_removed", (member) => {
            this.removeUser(member.info);
        });
    }

    private addUser(user : Objects.User) {
        // console.log("connected user --->", user.id);
        this.store.dispatch(new fromUsersOnlineActions.Connect(user.id));
    }

    private removeUser(user: Objects.User) {
        // console.log("disconnected user --->",user);
        this.store.dispatch(new fromUsersOnlineActions.Disconnect(user.id));
    }

    selectConnectedUserIds = (): Observable<string[]> => this.store.select( fromUsersOnlineState.usersOnlineMembersSelector);

    isOnline = (uid: string) : boolean => this.members.some((id) => uid === id);
}